import { Pipe, PipeTransform } from '@angular/core';
import { toWallClock } from '@services/helpers/wall-clock.util';

/** `{{ inspection.event.start.dateTime | wallClock | date: 'EEEE, d MMM y' }}` — see `toWallClock`. */
@Pipe({
  name: 'wallClock',
  pure: true,
})
export class WallClockPipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string | null {
    return toWallClock(value);
  }
}
